import { useEffect, useState } from 'react';

import { HELPER_NAV_SCROLL_THRESHOLD } from '@/components/GlobalNavigation/DesktopNav/DesktopNav';

const useHideNav = (
  scrollPosition: number,
  scrollDirection: string,
  hoverStateActive = false,
  navFocused = false
) => {
  const [hideNav, setHideNav] = useState(false);

  // Hide or display nav with animation
  useEffect(() => {
    // Scroll up and show banner with animations before top of page. Dont do it if already at the top of page
    if (
      (scrollDirection === 'up' &&
        scrollPosition >= HELPER_NAV_SCROLL_THRESHOLD &&
        !hoverStateActive) ||
      navFocused
    ) {
      setHideNav(false);
    }

    if (
      scrollDirection === 'down' &&
      scrollPosition >= HELPER_NAV_SCROLL_THRESHOLD
    ) {
      setHideNav(true);
    }
  }, [scrollPosition, scrollDirection, navFocused]);

  return hideNav;
};

export default useHideNav;
